import { GraphQLClient } from "graphql-request";

// Get the Hygraph endpoint from environment variables
const endpoint = import.meta.env.VITE_HYGRAPH_ENDPOINT || "";

// Create GraphQL client
export const hygraphClient = new GraphQLClient(endpoint, {
    headers: {},
});

// If you have a content API token, you can add it here:
// headers: {
//   Authorization: `Bearer ${import.meta.env.VITE_HYGRAPH_TOKEN}`,
// },
